import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Button } from '@/components/ui/daisy';

type ErrorMessageProps = {
  text: string;
  className?: string;
  onRetry?: () => void;
};

export default function ErrorMessage({
  text,
  className,
  onRetry,
}: ErrorMessageProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  return (
    <div
      className={twMerge(
        'flex h-full w-full flex-1 flex-col items-center justify-center gap-2',
        className,
      )}
    >
      <span className="text-sm text-error">{text}</span>
      <ConditionalRenderer condition={!!onRetry}>
        <Button type="button" size="sm" variant="soft" onClick={onRetry}>
          {t('tryAgain')}
        </Button>
      </ConditionalRenderer>
    </div>
  );
}
